import(/* webpackMode: "eager" */ "/app/src/app/(auth)/auth/template.tsx");
